export const DoubleDown = () => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="17" fill="white" stroke="#F06D24" strokeWidth="2" />
    <path
      d="M23 19L18 24L13 19"
      stroke="#F06D24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 12L18 17L13 12"
      stroke="#F06D24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
